import { palette } from '@signal/theme/overrides'
import * as constantsModule from '../variables/constants'

const constants = { ...constantsModule }
/**
 * Material UI Theme Overrides
 */
export const overrides = {
  constants,
  overrides: {
    MuiTabs: {
      indicator: {
        backgroundColor: palette.primary.main
      }
    },
    MuiTab: {
      root: {
        textTransform: 'uppercase',
        '@media (min-width: 960px)': {
          minWidth: 100
        }
      }
    }
  },
  palette: {
    type: 'dark',
    textImageFilter: 'brightness(0) invert(1)',
    text: {
      deep: '#ffffff',
      dark: '#ffffff',
      primary: '#ffffff',
      secondary: '#c5c6c5',
      disabled: 'rgba(255, 255, 255, 0.5)',
      hint: 'rgba(255, 255, 255, 0.5)',
      icon: 'rgba(255, 255, 255, 0.5)',
      primaryDark: '#fff',
      primaryLight: '#fff',
      altDark: '#fff',
      map: '#999'
    },
    background: {
      lightBlue: '#363636',
      lightest: '#414141',
      light: '#363636',
      paper: '#2d2d2d',
      road: '#666',
      water: '#1e1e1e',
      default: '#1e1e1e'
    },
    divider: 'rgba(255, 255, 255, 0.12)',
    action: {
      active: '#ffffff',
      hover: 'rgba(255, 255, 255, 0.08)',
      hoverOpacity: 0.08,
      selected: 'rgba(255, 255, 255, 0.16)',
      selectedOpacity: 0.16,
      disabled: 'rgba(255, 255, 255, 0.3)',
      disabledBackground: 'rgba(255, 255, 255, 0.12)'
    }
  }
}

export default overrides
